import {
  Box,
  Grid,
  Typography,
  Container,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import logo from "../../assets/images/Latest Logo.png";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { styled } from "@mui/system";
import { BgColor, customTextColor } from "../../utils/const";
import { useState } from "react";
import Reporting from "./Reporting";
import SafeJob from "./SafeJob";
import DataBackup from "./DataBackUp";
import Website from "./Website";
import Privacy from "./Privacy";
import Refund from "./Refund";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";

const Security = ({ title, progress, color }) => {
  const navigate = useNavigate();
  const [typeResult, setTypeResult] = useState("privacy");
  const [menuOpen, setMenuOpen] = useState(false);


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>

      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <b>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Refund Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                {typeResult === "privacy" && <Privacy />}
                {typeResult === "refund" && <Refund />}
                {typeResult === "website" && <Website />}
                {typeResult === "dataBackup" && <DataBackup />}
                {typeResult === "safeJob" && <SafeJob />}
                {typeResult === "reporting" && <Reporting />}
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>

      <Footer />
    </Box>
  );
};

export default Security;
